import script from "./DeactivateProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./DeactivateProfile.vue?vue&type=script&setup=true&lang=js"

import "./DeactivateProfile.vue?vue&type=style&index=0&id=598d51c1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598d51c1"]])

export default __exports__